// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__pBqEa","sliderContainer":"Slider_sliderContainer__o3mQB","helper":"Slider_helper__LmFk9"};